<template>
    <div id="signin" class="center">
        <div class="form-signin">
            <form @submit.prevent="onSubmit">
                <h2 class="h3 mb-3 font-weight-normal">Please sign in</h2>
                <label for="email" class="sr-only">Email address</label>
                <input
                    type="email"
                    id="email"
                    v-model="email"
                    class="form-control"
                    placeholder="Email address"
                    required
                    autofocus
                />
                <label for="password" class="sr-only">Password</label>
                <input
                    type="password"
                    id="password"
                    v-model="password"
                    class="form-control"
                    placeholder="Password"
                    required
                />
                <button class="btn btn-lg btn-primary btn-block" type="submit">Submit</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password: "",
        };
    },
    methods: {
        onSubmit() {
            const formData = {
                email: this.email,
                password: this.password,
            };
            console.log(formData);
            this.$store.dispatch("login", {
                email: formData.email,
                password: formData.password,
            });
        },
    },
};
</script>

<style scoped>
.center {
    margin: auto;
    width: 50%;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>